module.exports = __webpack_public_path__ + "img/lisvig.fbd00ce2.jpg";